/* Zambezi Roots — Shopify theme interactions
   Adapted from the original prototype to use Shopify's AJAX Cart API. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var addUrl = routes.cart_add_url || '/cart/add.js';
  var changeUrl = routes.cart_change_url || '/cart/change.js';
  var cartUrl = routes.cart_url || '/cart';

  function zrEmit(name, detail) {
    if (window.ZRAnalytics && typeof window.ZRAnalytics.emit === 'function') {
      return window.ZRAnalytics.emit(name, detail);
    }
    return false;
  }

  function cartMetaFromLine(line) {
    if (!line) return {};
    return {
      product_id: line.getAttribute('data-product-id') || undefined,
      variant_id: line.getAttribute('data-variant-id') || undefined,
      product_handle: line.getAttribute('data-product-handle') || undefined,
      source: 'cart_page'
    };
  }

  function addMetaFromButton(btn) {
    if (!btn) return { source: 'product_card' };
    return {
      source: btn.getAttribute('data-source') || (btn.closest('.product-card') ? 'product_card' : 'product_grid'),
      product_id: btn.getAttribute('data-product-id') || undefined,
      variant_id: btn.getAttribute('data-variant-id') || undefined,
      product_handle: btn.getAttribute('data-product-handle') || undefined,
      product_title: btn.getAttribute('data-add') || undefined,
      product_type: btn.getAttribute('data-product-type') || undefined,
      price: btn.getAttribute('data-price') ? Number(btn.getAttribute('data-price')) : undefined,
      quantity: 1
    };
  }

  /* ---------- Toast ---------- */
  function toast(title, sub) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.querySelector('.t-title').textContent = title;
    t.querySelector('.t-sub').textContent = sub || '';
    t.classList.add('show');
    clearTimeout(window.__zrToast);
    window.__zrToast = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  window.zrToast = toast;

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n <= 0;
    });
    document.querySelectorAll('.cart-link').forEach(function (link) {
      var label = 'Cart, ' + n + ' ' + (n === 1 ? 'item' : 'items');
      link.setAttribute('aria-label', label);
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }
  function getCartRoot() {
    return document.querySelector('[data-cart-root]');
  }
  function setCartLoading(root, loading) {
    if (!root) return;
    root.classList.toggle('is-loading', loading);
    root.querySelectorAll('button, input').forEach(function (el) {
      if (el.name === 'checkout') return;
      el.disabled = loading;
    });
  }
  function announceCart(message) {
    var live = document.querySelector('[data-cart-live]');
    if (live) live.textContent = message || '';
  }
  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }
  function renderCart(message, focusSelector, analyticsMeta, quantityAfter) {
    return fetch(cartUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextMain = doc.getElementById('MainContent');
        var currentMain = document.getElementById('MainContent');
        if (nextMain && currentMain) {
          currentMain.innerHTML = nextMain.innerHTML;
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        announceCart(message || 'Cart updated.');
        if (analyticsMeta) {
          if (quantityAfter === 0) {
            zrEmit('cart_item_remove', Object.assign({}, analyticsMeta, { quantity: 0 }));
          } else if (typeof quantityAfter === 'number') {
            zrEmit('cart_quantity_update', Object.assign({}, analyticsMeta, { quantity: quantityAfter }));
          }
        }
        var target = focusSelector ? document.querySelector(focusSelector) : document.querySelector('[data-cart-root]');
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
        return cart;
      });
  }

  function addVariant(variantId, qty, name, meta) {
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast('Could not add', (res.data && res.data.description) || 'Please choose options');
          return;
        }
        zrEmit('add_to_cart', Object.assign({}, meta || {}, {
          variant_id: variantId,
          quantity: qty || 1,
          product_title: (meta && meta.product_title) || name || undefined,
          source: (meta && meta.source) || 'product_card'
        }));
        refreshCart();
        toast('Added to bag', name || '');
        if (getCartRoot()) return renderCart((name || 'Item') + ' added to cart.');
      })
      .catch(function () { toast('Network error', 'Please try again'); });
  }

  /* ---------- Add-to-cart buttons (grids + cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var isComing = btn.getAttribute('data-coming') === '1';
    if (isComing) {
      toast('Coming soon', btn.getAttribute('data-add') + " isn't available yet — join our email list for launch updates");
      return;
    }
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) { window.location.href = btn.closest('a') ? btn.closest('a').href : cartUrl; return; }
    addVariant(variantId, 1, btn.getAttribute('data-add'), addMetaFromButton(btn));
  });

  /* ---------- Cart page AJAX controls ---------- */
  var cartBusy = false;
  function changeCartLine(key, quantity, message, focusSelector, analyticsMeta) {
    var root = getCartRoot();
    if (!root || cartBusy) return Promise.resolve();
    cartBusy = true;
    setCartLoading(root, true);
    quantity = Math.max(0, Number(quantity) || 0);
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not update cart.');
        return renderCart(message || 'Cart updated.', focusSelector, analyticsMeta, quantity);
      })
      .catch(function (error) {
        setCartLoading(root, false);
        announceCart(error.message || 'Could not update cart.');
        toast('Cart not updated', error.message || 'Please try again');
      })
      .finally(function () {
        cartBusy = false;
        var nextRoot = getCartRoot();
        setCartLoading(nextRoot, false);
      });
  }

  document.addEventListener('click', function (e) {
    var qtyButton = e.target.closest('[data-cart-qty]');
    if (qtyButton) {
      e.preventDefault();
      var line = qtyButton.closest('[data-cart-line]');
      var input = line && line.querySelector('[data-cart-qty-input]');
      if (!line || !input) return;
      var nextQty = Math.max(0, (Number(input.value) || 0) + Number(qtyButton.getAttribute('data-cart-qty')));
      var key = line.getAttribute('data-line-key');
      changeCartLine(key, nextQty, nextQty === 0 ? 'Item removed from cart.' : 'Quantity updated.', '[data-cart-line][data-line-key="' + escapeSelector(key) + '"] [data-cart-qty-input]', cartMetaFromLine(line));
      return;
    }

    var removeButton = e.target.closest('[data-cart-remove]');
    if (removeButton) {
      e.preventDefault();
      var removeLine = removeButton.closest('[data-cart-line]');
      if (!removeLine) return;
      changeCartLine(removeLine.getAttribute('data-line-key'), 0, 'Item removed from cart.', '[data-cart-root]', cartMetaFromLine(removeLine));
      return;
    }

    var crossButton = e.target.closest('[data-cart-cross-add]');
    if (crossButton) {
      e.preventDefault();
      if (cartBusy) return;
      var root = getCartRoot();
      var errorEl = crossButton.closest('.cart-cross-card') && crossButton.closest('.cart-cross-card').querySelector('[data-cart-cross-error]');
      cartBusy = true;
      setCartLoading(root, true);
      crossButton.textContent = 'Adding...';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(crossButton.getAttribute('data-variant-id')), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) { return { ok: response.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add this item.');
          zrEmit('add_to_cart', {
            variant_id: crossButton.getAttribute('data-variant-id') || undefined,
            product_title: crossButton.getAttribute('data-title') || undefined,
            source: 'cart_cross_sell',
            quantity: 1
          });
          return renderCart((crossButton.getAttribute('data-title') || 'Item') + ' added to cart.', '[data-cart-root]');
        })
        .catch(function (error) {
          if (errorEl) errorEl.textContent = error.message || 'Could not add this item.';
          announceCart(error.message || 'Could not add this item.');
          toast('Could not add', error.message || 'Please try again');
        })
        .finally(function () {
          cartBusy = false;
          setCartLoading(getCartRoot(), false);
          crossButton.textContent = 'Add to Cart';
        });
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-qty-input]');
    if (!qtyInput) return;
    var line = qtyInput.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = Math.max(0, Number(qtyInput.value) || 0);
    changeCartLine(key, qty, qty === 0 ? 'Item removed from cart.' : 'Quantity updated.', '[data-cart-line][data-line-key="' + escapeSelector(key) + '"] [data-cart-qty-input]', cartMetaFromLine(line));
  });

  /* ---------- Overlay priority: consent > bundle > newsletter > chat ----------
     IMPORTANT: syncOverlayState() writes body classes and overlay
     attributes. All DOM writes below are change-guarded and the
     MutationObserver is debounced through requestSync(); a callback
     that mutates observed attributes synchronously re-queues itself
     as a microtask forever and blocks DOMContentLoaded. */
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var CONSENT_SELECTORS = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '#shopify-pc__prefs_dialog',
    '#shopify-pc__prefs_modal',
    '#shopify-pc__banner__dialog',
    '[id^="shopify-pc__"]',
    '.shopify-pc__banner',
    '.shopify-pc-banner',
    '[data-testid="privacy-banner"]'
  ].join(',');
  var POST_CONSENT_DELAY_MS = 2500;
  var SYNC_DEBOUNCE_MS = 150;
  var DAY_MS = 86400000;
  var PAGE_LOADED_AT = Date.now();
  var consentWasVisible = false;
  var promoTimer = null;
  var bundleShown = false;
  var newsletterShown = false;
  var promoPending = false;
  var syncTimer = null;
  var syncing = false;
  var bundleReturnFocus = null;
  var newsletterReturnFocus = null;
  var sizeGuideReturnFocus = null;
  var bundleOverlay = document.getElementById('bundleModal');
  var newsletterOverlay = document.getElementById('emailModal');
  var overlay = newsletterOverlay;

  function isHomePage() {
    return document.body.classList.contains('home-page');
  }

  function isOurStoryPage() {
    if (!document.body.classList.contains('template-page')) return false;
    var path = (window.location.pathname || '').toLowerCase();
    return path.indexOf('/pages/our-story') !== -1 || path.indexOf('/pages/about-us') !== -1;
  }

  function refreshOverlayNodes() {
    bundleOverlay = document.getElementById('bundleModal') || bundleOverlay;
    newsletterOverlay = document.getElementById('emailModal') || newsletterOverlay;
    overlay = newsletterOverlay;
  }

  function newsletterConfig() {
    var el = newsletterOverlay || {};
    var get = function (attr, fallback) {
      var v = el.getAttribute ? Number(el.getAttribute(attr)) : NaN;
      return isNaN(v) || v <= 0 ? fallback : v;
    };
    return {
      delayMs: get('data-popup-delay', 10) * 1000,
      dismissMs: get('data-popup-dismiss-days', 7) * DAY_MS,
      subscribedMs: get('data-popup-subscribed-days', 30) * DAY_MS
    };
  }

  function bundleConfig() {
    var el = bundleOverlay || {};
    var get = function (attr, fallback) {
      var v = el.getAttribute ? Number(el.getAttribute(attr)) : NaN;
      return isNaN(v) || v <= 0 ? fallback : v;
    };
    var seconds = Math.min(8, Math.max(6, get('data-bundle-delay', 7)));
    return { delayMs: seconds * 1000 };
  }

  function popupConfig() { return newsletterConfig(); }

  function storageGet(store, key) {
    try { return store.getItem(key); } catch (err) { return null; }
  }
  function storageSet(store, key, value) {
    try { store.setItem(key, value); } catch (err) {}
  }

  function promoModalShownSession() {
    return !!storageGet(sessionStorage, 'zr_promotional_modal_shown_session');
  }

  function markPromoModalShownSession() {
    storageSet(sessionStorage, 'zr_promotional_modal_shown_session', '1');
  }

  function bundleSessionSuppressed() {
    return !!(storageGet(sessionStorage, 'zr_bundle_popup_shown') || storageGet(sessionStorage, 'zr_bundle_popup_dismissed'));
  }

  function newsletterSuppressed() {
    var cfg = newsletterConfig();
    if (storageGet(sessionStorage, 'zr_popup_session_shown') || storageGet(sessionStorage, 'zr_popup')) return true;
    var dismissed = Number(storageGet(localStorage, 'zr_popup_dismissed_at'));
    if (dismissed && Date.now() - dismissed < cfg.dismissMs) return true;
    var subscribed = Number(storageGet(localStorage, 'zr_popup_subscribed_at'));
    if (subscribed && Date.now() - subscribed < cfg.subscribedMs) return true;
    return false;
  }

  function popupSuppressed() { return newsletterSuppressed(); }

  function isGroupOrdersPage() {
    return (window.location.pathname || '').toLowerCase().indexOf('/pages/group-orders') !== -1;
  }

  function formInteractionSuppressed() {
    return !!storageGet(sessionStorage, 'zr_form_interaction_session');
  }

  function groupOrderValidationVisible() {
    var summary = document.querySelector('[data-group-order-error-summary]:not([hidden])');
    return !!summary;
  }

  function suppressPromosForFormInteraction() {
    if (DESIGN_MODE) return;
    storageSet(sessionStorage, 'zr_form_interaction_session', '1');
    promoPending = false;
    clearTimeout(promoTimer);
    hideBundleDom();
    hideNewsletterDom();
    requestSync();
  }

  function overlayBlockedByForm() {
    if (formInteractionSuppressed()) return true;
    if (!isGroupOrdersPage()) return false;
    if (groupOrderValidationVisible()) return true;
    var goForm = document.querySelector('.group-order-form');
    if (goForm && goForm.contains(document.activeElement)) return true;
    return false;
  }

  function emitPopupEvent(name, detail) {
    zrEmit(name, detail);
  }

  function setBodyClass(name, on) {
    if (document.body.classList.contains(name) === !!on) return;
    document.body.classList.toggle(name, !!on);
  }

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function consentBannerRequired() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
        return !!window.Shopify.customerPrivacy.shouldShowBanner();
      }
    } catch (err) {}
    return null;
  }

  function isConsentVisible() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
        if (!window.Shopify.customerPrivacy.shouldShowBanner()) return false;
      }
    } catch (err) {}
    var nodes = document.querySelectorAll(CONSENT_SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      if (isElementVisible(nodes[i])) return true;
    }
    return false;
  }

  function isBundleOpen() {
    return !!(bundleOverlay && bundleOverlay.classList.contains('open'));
  }

  function isNewsletterOpen() {
    return !!(newsletterOverlay && newsletterOverlay.classList.contains('open'));
  }

  function getSizeGuideOverlay() {
    return document.getElementById('productSizeGuideModal');
  }

  function isSizeGuideOpen() {
    var overlayEl = getSizeGuideOverlay();
    return !!(overlayEl && overlayEl.classList.contains('open'));
  }

  function isPromoOpen() {
    return isBundleOpen() || isNewsletterOpen();
  }

  function hideBundleDom() {
    if (!bundleOverlay) return;
    if (bundleOverlay.classList.contains('open')) bundleOverlay.classList.remove('open');
    if (!bundleOverlay.hidden) bundleOverlay.hidden = true;
    if (bundleOverlay.getAttribute('aria-hidden') !== 'true') bundleOverlay.setAttribute('aria-hidden', 'true');
    setBodyClass('zr-overlay-bundle', false);
  }

  function hideNewsletterDom() {
    if (!newsletterOverlay) return;
    if (newsletterOverlay.classList.contains('open')) newsletterOverlay.classList.remove('open');
    if (!newsletterOverlay.hidden) newsletterOverlay.hidden = true;
    if (newsletterOverlay.getAttribute('aria-hidden') !== 'true') newsletterOverlay.setAttribute('aria-hidden', 'true');
    setBodyClass('zr-overlay-promo', false);
  }

  function hidePromoDom() { hideNewsletterDom(); }

  function bundleAnalyticsDetail() {
    return {
      source: 'bundle_popup',
      discount_code: bundleOverlay ? (bundleOverlay.getAttribute('data-bundle-code') || 'AFRICAZ') : 'AFRICAZ'
    };
  }

  function setBundleOpen(open) {
    refreshOverlayNodes();
    if (!bundleOverlay || bundleOverlay.getAttribute('data-bundle-enabled') !== 'true') return;
    if (open) {
      bundleReturnFocus = document.activeElement;
      if (bundleOverlay.hidden) bundleOverlay.hidden = false;
      if (bundleOverlay.getAttribute('aria-hidden') !== 'false') bundleOverlay.setAttribute('aria-hidden', 'false');
      if (!bundleOverlay.classList.contains('open')) bundleOverlay.classList.add('open');
      setBodyClass('zr-overlay-bundle', true);
      bundleShown = true;
      if (!DESIGN_MODE) {
        storageSet(sessionStorage, 'zr_bundle_popup_shown', '1');
        markPromoModalShownSession();
      }
      emitPopupEvent('zr:bundle_promo_open', bundleAnalyticsDetail());
      var focusTarget = bundleOverlay.querySelector('[data-bundle-close], [data-bundle-copy-code], a, button');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    } else {
      var wasOpen = isBundleOpen();
      hideBundleDom();
      if (wasOpen) {
        emitPopupEvent('zr:bundle_promo_close', bundleAnalyticsDetail());
        if (bundleReturnFocus && document.contains(bundleReturnFocus) && typeof bundleReturnFocus.focus === 'function') {
          bundleReturnFocus.focus();
        }
        bundleReturnFocus = null;
      }
    }
    requestSync();
  }

  function closeBundle() {
    refreshOverlayNodes();
    if (!bundleOverlay) return;
    setBundleOpen(false);
    if (DESIGN_MODE) return;
    storageSet(sessionStorage, 'zr_bundle_popup_dismissed', '1');
  }

  function setNewsletterOpen(open) {
    refreshOverlayNodes();
    if (!newsletterOverlay) return;
    if (open) {
      newsletterReturnFocus = document.activeElement;
      if (newsletterOverlay.hidden) newsletterOverlay.hidden = false;
      if (newsletterOverlay.getAttribute('aria-hidden') !== 'false') newsletterOverlay.setAttribute('aria-hidden', 'false');
      if (!newsletterOverlay.classList.contains('open')) newsletterOverlay.classList.add('open');
      setBodyClass('zr-overlay-promo', true);
      newsletterShown = true;
      if (!DESIGN_MODE) {
        storageSet(sessionStorage, 'zr_popup_session_shown', '1');
        markPromoModalShownSession();
      }
      emitPopupEvent('zr:newsletter_popup_open');
      var focusTarget = newsletterOverlay.querySelector('[data-popup-success]') || newsletterOverlay.querySelector('input, button');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    } else {
      var wasOpen = isNewsletterOpen();
      hideNewsletterDom();
      if (wasOpen) {
        emitPopupEvent('zr:newsletter_popup_close');
        if (newsletterReturnFocus && document.contains(newsletterReturnFocus) && typeof newsletterReturnFocus.focus === 'function') {
          newsletterReturnFocus.focus();
        }
        newsletterReturnFocus = null;
      }
    }
    requestSync();
  }

  function setPromoOpen(open) { setNewsletterOpen(open); }

  function closeNewsletter() {
    refreshOverlayNodes();
    if (!newsletterOverlay) return;
    var subscribedState = !!newsletterOverlay.querySelector('[data-popup-success]');
    setNewsletterOpen(false);
    if (DESIGN_MODE) return;
    if (!subscribedState) storageSet(localStorage, 'zr_popup_dismissed_at', String(Date.now()));
  }

  function closePromo() { closeNewsletter(); }

  function hideSizeGuideDom() {
    var overlayEl = getSizeGuideOverlay();
    if (!overlayEl) return;
    if (overlayEl.classList.contains('open')) overlayEl.classList.remove('open');
    if (!overlayEl.hidden) overlayEl.hidden = true;
    if (overlayEl.getAttribute('aria-hidden') !== 'true') overlayEl.setAttribute('aria-hidden', 'true');
    setBodyClass('zr-size-guide-open', false);
  }

  function suppressPromosForSizeGuide() {
    if (DESIGN_MODE) return;
    promoPending = false;
    clearTimeout(promoTimer);
    hideBundleDom();
    hideNewsletterDom();
    suppressChat();
  }

  function openProductSizeGuide(trigger) {
    var overlayEl = getSizeGuideOverlay();
    if (!overlayEl) return;
    suppressPromosForSizeGuide();
    sizeGuideReturnFocus = trigger && document.contains(trigger) ? trigger : document.activeElement;
    if (overlayEl.hidden) overlayEl.hidden = false;
    if (overlayEl.getAttribute('aria-hidden') !== 'false') overlayEl.setAttribute('aria-hidden', 'false');
    if (!overlayEl.classList.contains('open')) overlayEl.classList.add('open');
    setBodyClass('zr-size-guide-open', true);
    var dialog = overlayEl.querySelector('[role="dialog"]');
    var focusTarget = overlayEl.querySelector('[data-size-guide-close]') || dialog;
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    zrEmit('size_guide_open', {
      product_id: overlayEl.getAttribute('data-product-id') || null,
      product_handle: overlayEl.getAttribute('data-product-handle') || null,
      product_type: overlayEl.getAttribute('data-size-guide-type') || null,
      source: 'product_page_modal'
    });
    requestSync();
  }

  function closeProductSizeGuide() {
    var overlayEl = getSizeGuideOverlay();
    if (!overlayEl) return;
    var wasOpen = isSizeGuideOpen();
    hideSizeGuideDom();
    if (wasOpen && sizeGuideReturnFocus && document.contains(sizeGuideReturnFocus) && typeof sizeGuideReturnFocus.focus === 'function') {
      sizeGuideReturnFocus.focus();
    }
    sizeGuideReturnFocus = null;
    requestSync();
  }

  function initProductSizeGuideModal() {
    var overlayEl = getSizeGuideOverlay();
    if (!overlayEl || overlayEl.getAttribute('data-size-guide-init') === 'true') return;
    overlayEl.setAttribute('data-size-guide-init', 'true');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-size-guide-open]');
      if (trigger) {
        e.preventDefault();
        openProductSizeGuide(trigger);
        return;
      }
      if (!isSizeGuideOpen()) return;
      if (e.target === overlayEl || e.target.closest('[data-size-guide-close]')) {
        closeProductSizeGuide();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!isSizeGuideOpen()) return;
      if (e.key === 'Escape') {
        if (isConsentVisible()) return;
        e.preventDefault();
        closeProductSizeGuide();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = overlayEl.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      items = Array.prototype.filter.call(items, function (node) {
        return node.offsetParent !== null || node === document.activeElement;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!overlayEl.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function overlayBlockedByUi() {
    if (document.body.classList.contains('zr-menu-open')) return true;
    if (document.body.classList.contains('zr-overlay-chat')) return true;
    if (isSizeGuideOpen()) return true;
    if (overlayBlockedByForm()) return true;
    return false;
  }

  function canShowBundle() {
    refreshOverlayNodes();
    if (!bundleOverlay || bundleOverlay.getAttribute('data-bundle-enabled') !== 'true') return false;
    if (!isHomePage() || bundleShown || isBundleOpen() || isConsentVisible()) return false;
    if (overlayBlockedByUi() || isNewsletterOpen()) return false;
    if (formInteractionSuppressed()) return false;
    if (bundleSessionSuppressed() || promoModalShownSession()) return false;
    return true;
  }

  function canShowNewsletter() {
    refreshOverlayNodes();
    if (!newsletterOverlay) return false;
    if (!isOurStoryPage() || newsletterShown || isNewsletterOpen() || isConsentVisible()) return false;
    if (overlayBlockedByUi() || isBundleOpen()) return false;
    if (formInteractionSuppressed()) return false;
    if (newsletterSuppressed() || promoModalShownSession()) return false;
    return true;
  }

  function canShowPromo() { return canShowNewsletter(); }

  function suppressChat() {
    setBodyClass('zr-chat-suppressed', true);
    if (window.zrChat && typeof window.zrChat.suppress === 'function') window.zrChat.suppress();
  }

  function restoreChatIfClear() {
    if (isConsentVisible() || isPromoOpen() || promoPending) return;
    setBodyClass('zr-chat-suppressed', false);
    if (window.zrChat && typeof window.zrChat.restore === 'function') window.zrChat.restore();
  }

  function activePromoDelayMs() {
    if (isHomePage() && bundleOverlay && bundleOverlay.getAttribute('data-bundle-enabled') === 'true') {
      return bundleConfig().delayMs;
    }
    if (isOurStoryPage() && newsletterOverlay) return newsletterConfig().delayMs;
    return POST_CONSENT_DELAY_MS;
  }

  function schedulePromo(delay) {
    if (DESIGN_MODE) return;
    var canBundle = canShowBundle();
    var canNewsletter = canShowNewsletter();
    if (!canBundle && !canNewsletter) {
      promoPending = false;
      restoreChatIfClear();
      return;
    }
    promoPending = true;
    suppressChat();
    clearTimeout(promoTimer);
    promoTimer = setTimeout(function () {
      promoPending = false;
      if (canShowBundle()) {
        setBundleOpen(true);
        return;
      }
      if (canShowNewsletter()) {
        setNewsletterOpen(true);
        return;
      }
      restoreChatIfClear();
    }, delay);
  }

  function syncOverlayState() {
    if (syncing) return;
    syncing = true;
    try {
      refreshOverlayNodes();
      var consentActive = isConsentVisible();
      var bundleActive = isBundleOpen();
      var newsletterActive = isNewsletterOpen();

      setBodyClass('zr-overlay-consent', consentActive);
      setBodyClass('zr-overlay-bundle', bundleActive);
      setBodyClass('zr-overlay-promo', newsletterActive);

      if (consentActive) {
        consentWasVisible = true;
        promoPending = false;
        clearTimeout(promoTimer);
        if (bundleActive) hideBundleDom();
        if (newsletterActive) hideNewsletterDom();
        suppressChat();
        return;
      }

      if (consentWasVisible) {
        consentWasVisible = false;
        schedulePromo(remainingPromoDelay());
        return;
      }

      if (bundleActive || newsletterActive || promoPending) {
        suppressChat();
        return;
      }

      restoreChatIfClear();
    } finally {
      syncing = false;
    }
  }

  function requestSync() {
    if (syncTimer) return;
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncOverlayState();
    }, SYNC_DEBOUNCE_MS);
  }

  function remainingPromoDelay() {
    var elapsed = Date.now() - PAGE_LOADED_AT;
    return Math.max(activePromoDelayMs() - elapsed, POST_CONSENT_DELAY_MS);
  }

  function watchConsent() {
    syncOverlayState();
    var observer = new MutationObserver(requestSync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });

    document.addEventListener('visitorConsentCollected', function () {
      consentWasVisible = true;
      requestSync();
      schedulePromo(remainingPromoDelay());
    });

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        requestSync();
        if (consentBannerRequired() === false && !isConsentVisible()) {
          schedulePromo(remainingPromoDelay());
        }
      });
    }

    setTimeout(function () {
      if (!isConsentVisible()) {
        schedulePromo(remainingPromoDelay());
      }
    }, activePromoDelayMs());
  }

  if (!window.__zrOverlayHandlersInit) {
    window.__zrOverlayHandlersInit = true;

    document.addEventListener('click', function (e) {
      refreshOverlayNodes();
      var bundle = document.getElementById('bundleModal');
      if (bundle && !bundle.hidden) {
        if (e.target === bundle || e.target.closest('[data-bundle-close]')) {
          closeBundle();
          return;
        }
        var scrubCta = e.target.closest('[data-bundle-scrub-cta]');
        if (scrubCta) {
          emitPopupEvent('zr:bundle_promo_scrub_click', Object.assign({}, bundleAnalyticsDetail(), { destination_type: 'collection' }));
          return;
        }
        var lanyardCta = e.target.closest('[data-bundle-lanyard-cta]');
        if (lanyardCta) {
          emitPopupEvent('zr:bundle_promo_lanyard_click', Object.assign({}, bundleAnalyticsDetail(), { destination_type: 'collection' }));
          return;
        }
        var copyBtn = e.target.closest('[data-bundle-copy-code]');
        if (copyBtn) {
          var code = bundle.getAttribute('data-bundle-code') || '';
          var status = bundle.querySelector('[data-bundle-copy-status]');
          var defaultLabel = copyBtn.getAttribute('data-default-label') || copyBtn.textContent.trim();
          if (!copyBtn.getAttribute('data-default-label')) copyBtn.setAttribute('data-default-label', defaultLabel);
          if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') return;
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'CODE COPIED';
            if (status) status.textContent = 'Discount code copied to clipboard.';
            emitPopupEvent('zr:bundle_promo_code_copy', bundleAnalyticsDetail());
            setTimeout(function () {
              copyBtn.textContent = defaultLabel;
              if (status) status.textContent = '';
            }, 2200);
          }).catch(function () {
            if (status) status.textContent = 'Copy failed. Use the discount link buttons instead.';
          });
        }
      }

      var current = document.getElementById('emailModal');
      if (!current || current.hidden) return;
      newsletterOverlay = current;
      overlay = current;
      if (e.target === current || e.target.closest('#emailModal .close') || e.target.closest('#emailModal [data-popup-done]')) closeNewsletter();
    });

    document.addEventListener('keydown', function (e) {
      if (isSizeGuideOpen()) return;
      var activeModal = isBundleOpen() ? bundleOverlay : (isNewsletterOpen() ? newsletterOverlay : null);
      if (!activeModal) return;
      if (e.key === 'Escape') {
        if (isConsentVisible()) return;
        e.preventDefault();
        if (activeModal === bundleOverlay) closeBundle();
        else closeNewsletter();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = activeModal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!activeModal.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (bundleOverlay) {
    bundleOverlay.hidden = true;
    bundleOverlay.setAttribute('aria-hidden', 'true');
  }

  if (newsletterOverlay) {
    newsletterOverlay.hidden = true;
    newsletterOverlay.setAttribute('aria-hidden', 'true');

    var mform = newsletterOverlay.querySelector('.popup-newsletter-form');
    if (mform) mform.setAttribute('novalidate', '');
    if (mform) mform.addEventListener('submit', function (e) {
      refreshOverlayNodes();
      var emailInput = mform.querySelector('input[name="contact[email]"]');
      var clientError = newsletterOverlay.querySelector('[data-popup-client-error]');
      if (!emailInput) return;
      var value = emailInput.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!valid) {
        e.preventDefault();
        if (clientError) {
          clientError.textContent = value === '' ? 'Please enter your email address.' : 'Please enter a valid email address.';
          clientError.hidden = false;
        }
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.setAttribute('aria-describedby', 'emailModalError');
        emailInput.focus();
        emitPopupEvent('zr:newsletter_signup_error');
        return;
      }
      if (clientError) clientError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
      var submitBtn = mform.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
    });

    if (!DESIGN_MODE) {
      if (newsletterOverlay.querySelector('[data-popup-success]')) {
        storageSet(localStorage, 'zr_popup_subscribed_at', String(Date.now()));
        emitPopupEvent('zr:newsletter_signup_success');
        setTimeout(function () { setNewsletterOpen(true); }, 300);
      } else if (newsletterOverlay.querySelector('[data-popup-server-error]')) {
        emitPopupEvent('zr:newsletter_signup_error');
        setTimeout(function () { setNewsletterOpen(true); }, 300);
      }
    }
  }

  if (!window.__zrOverlayInit) {
    window.__zrOverlayInit = true;
    if (DESIGN_MODE) {
      document.addEventListener('shopify:section:load', function () {
        refreshOverlayNodes();
        requestSync();
      });
      document.addEventListener('shopify:section:unload', requestSync);
      document.addEventListener('shopify:section:select', function (e) {
        refreshOverlayNodes();
        if (bundleOverlay && e.target && e.target.contains(bundleOverlay)) setBundleOpen(true);
        if (newsletterOverlay && e.target && e.target.contains(newsletterOverlay)) setNewsletterOpen(true);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        refreshOverlayNodes();
        if (bundleOverlay && e.target && e.target.contains(bundleOverlay)) setBundleOpen(false);
        if (newsletterOverlay && e.target && e.target.contains(newsletterOverlay)) setNewsletterOpen(false);
      });
      syncOverlayState();
    } else {
      watchConsent();
    }
  }
  window.zrOverlay = {
    isConsentVisible: isConsentVisible,
    isPromoOpen: isPromoOpen,
    isBundleOpen: isBundleOpen,
    isNewsletterOpen: isNewsletterOpen,
    sync: requestSync
  };

  /* ---------- Mobile navigation drawer ----------
     Delegated listeners so Theme Editor section reloads never require
     re-binding; guarded so the module initialises exactly once. */
  if (!window.__zrNavInit) {
    window.__zrNavInit = true;

    var navTrigger = null;

    function getNav() { return document.querySelector('[data-mobile-nav]'); }
    function getToggle() { return document.querySelector('[data-nav-toggle]'); }
    function navIsOpen() {
      var nav = getNav();
      return !!(nav && !nav.hidden);
    }

    function navFocusables(nav) {
      return nav.querySelectorAll('a[href], button:not([disabled])');
    }

    function openNav(trigger) {
      var nav = getNav();
      if (!nav || !nav.hidden) return;
      navTrigger = trigger || getToggle();
      nav.hidden = false;
      document.body.classList.add('zr-menu-open');
      var toggle = navTrigger || getToggle();
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
      }
      var main = document.getElementById('MainContent');
      if (main) main.setAttribute('aria-hidden', 'true');
      var first = nav.querySelector('.mobile-nav-close') || navFocusables(nav)[0];
      if (first) setTimeout(function () { first.focus(); }, 30);
    }

    function closeNav() {
      var nav = getNav();
      if (!nav || nav.hidden) return;
      nav.hidden = true;
      document.body.classList.remove('zr-menu-open');
      var toggle = getToggle();
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      }
      var main = document.getElementById('MainContent');
      if (main) main.removeAttribute('aria-hidden');
      var focusTarget = navTrigger || toggle;
      if (focusTarget && document.contains(focusTarget)) focusTarget.focus();
      navTrigger = null;
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-nav-toggle]');
      if (toggle) {
        e.preventDefault();
        if (navIsOpen()) closeNav();
        else openNav(toggle);
        return;
      }
      if (e.target.closest('[data-nav-close]')) {
        e.preventDefault();
        closeNav();
        return;
      }
      var navLink = e.target.closest('.mobile-nav-links a');
      if (navLink && navIsOpen()) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (!navIsOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeNav();
        return;
      }
      if (e.key !== 'Tab') return;
      // Keep focus inside the drawer while it is open.
      var nav = getNav();
      var items = navFocusables(nav);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!nav.contains(document.activeElement)) {
      e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('shopify:section:unload', function () {
      document.body.classList.remove('zr-menu-open');
    });
  }

  /* ---------- Size selectors (PDP) ---------- */
  document.querySelectorAll('.size-opts').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var opt = e.target.closest('.size-opt');
      if (!opt) return;
      if (opt.disabled || opt.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      group.querySelectorAll('.size-opt').forEach(function (o) {
        o.classList.remove('selected');
        o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('selected');
      opt.setAttribute('aria-pressed', 'true');
      if (window.zrUpdateVariant) window.zrUpdateVariant();
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    var dec = q.querySelector('[data-step="-1"]');
    var inc = q.querySelector('[data-step="1"]');
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = parseInt(input.value, 10) + 1; });
  });

  /* ---------- Accessible accordion ----------
     Works for FAQ on the Group Orders page and any other .acc-item blocks. */
  function syncAccordionItem(item, open) {
    var head = item.querySelector('.acc-head');
    var body = item.querySelector('.acc-body');
    item.classList.toggle('open', open);
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (body) {
      if (body.hasAttribute('hidden')) body.hidden = !open;
    }
  }

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var item = head.parentElement;
    if (!item || !item.classList.contains('acc-item')) return;
    syncAccordionItem(item, !item.classList.contains('open'));
  });

  /* ---------- Group order enquiry form ---------- */
  if (!window.__zrGroupOrderInit) {
    window.__zrGroupOrderInit = true;

    var GO_HEADER_OFFSET = 96;
    var GO_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function emitGroupOrderEvent(name) {
      zrEmit(name);
    }

    function getGroupOrderForm() {
      return document.querySelector('.group-order-form');
    }

    function scrollToGroupOrderForm(focusTarget) {
      var section = document.getElementById('groupOrderForm');
      if (!section) return;
      var top = section.getBoundingClientRect().top + window.pageYOffset - GO_HEADER_OFFSET;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      setTimeout(function () {
        var el = focusTarget || document.getElementById('groupOrderFormTitle') || section.querySelector('input, select, textarea, button');
        if (el) {
          if (el === document.getElementById('groupOrderFormTitle')) el.setAttribute('tabindex', '-1');
          el.focus({ preventScroll: true });
        }
      }, 350);
    }

    function clearGroupOrderFieldError(fieldEl, errorEl) {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      if (fieldEl) fieldEl.removeAttribute('aria-invalid');
    }

    function setGroupOrderFieldError(fieldEl, errorEl, message) {
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (fieldEl) fieldEl.setAttribute('aria-invalid', 'true');
    }

    function clearGroupOrderValidation(form) {
      var summary = form.querySelector('[data-group-order-error-summary]');
      var list = form.querySelector('[data-group-order-error-list]');
      if (summary) summary.hidden = true;
      if (list) {
        list.innerHTML = '';
        list.hidden = true;
      }
      form.querySelectorAll('.field-error').forEach(function (node) {
        node.textContent = '';
        node.hidden = true;
      });
      form.querySelectorAll('[aria-invalid="true"]').forEach(function (node) {
        node.removeAttribute('aria-invalid');
      });
      var fieldset = form.querySelector('#goProductsFieldset');
      if (fieldset) fieldset.classList.remove('go-fieldset--error');
    }

    function validateGroupOrderForm(form) {
      clearGroupOrderValidation(form);
      var issues = [];
      var firstFocus = null;

      function addIssue(fieldEl, errorEl, label, message) {
        setGroupOrderFieldError(fieldEl, errorEl, message);
        issues.push({ label: label, message: message, fieldEl: fieldEl, errorEl: errorEl });
        if (!firstFocus && fieldEl) firstFocus = fieldEl;
      }

      var nameEl = form.querySelector('#goName');
      if (!nameEl || !nameEl.value.trim()) {
        addIssue(nameEl, form.querySelector('#goName-error'), 'Contact name', 'This field is required.');
      }

      var orgEl = form.querySelector('#goOrg');
      if (!orgEl || !orgEl.value.trim()) {
        addIssue(orgEl, form.querySelector('#goOrg-error'), 'Organisation name', 'This field is required.');
      }

      var emailEl = form.querySelector('#goEmail');
      var emailVal = emailEl ? emailEl.value.trim() : '';
      if (!emailVal) {
        addIssue(emailEl, form.querySelector('#goEmail-error'), 'Email', 'This field is required.');
      } else if (!GO_EMAIL_RE.test(emailVal)) {
        addIssue(emailEl, form.querySelector('#goEmail-error'), 'Email', 'Please enter a valid email address.');
      }

      var orgTypeEl = form.querySelector('#goOrgType');
      if (!orgTypeEl || !orgTypeEl.value) {
        addIssue(orgTypeEl, form.querySelector('#goOrgType-error'), 'Organisation type', 'This field is required.');
      }

      var teamSizeEl = form.querySelector('#goTeamSize');
      if (!teamSizeEl || !teamSizeEl.value) {
        addIssue(teamSizeEl, form.querySelector('#goTeamSize-error'), 'Estimated team size', 'This field is required.');
      }

      var productChecks = form.querySelectorAll('[data-go-product]');
      var anyProduct = false;
      for (var i = 0; i < productChecks.length; i++) {
        if (productChecks[i].checked) { anyProduct = true; break; }
      }
      var productsFieldset = form.querySelector('#goProductsFieldset');
      var productsError = form.querySelector('#goProducts-error');
      if (!anyProduct) {
        if (productsFieldset) productsFieldset.classList.add('go-fieldset--error');
        if (productsError) {
          productsError.textContent = 'Please select at least one product type.';
          productsError.hidden = false;
        }
        issues.push({ label: 'Products of interest', message: 'Please select at least one product type.', fieldEl: productsFieldset, errorEl: productsError });
        if (!firstFocus && productsFieldset) firstFocus = productChecks[0] || productsFieldset;
      }

      var qtyEl = form.querySelector('#goQuantities');
      var msgEl = form.querySelector('#goMessage');
      var hasQty = qtyEl && qtyEl.value.trim() !== '';
      var hasMsg = msgEl && msgEl.value.trim() !== '';
      var reqError = form.querySelector('#goRequirements-error');
      if (!hasQty && !hasMsg) {
        var reqMsg = 'Please provide approximate quantities or a message describing your requirements.';
        if (reqError) {
          reqError.textContent = reqMsg;
          reqError.hidden = false;
        }
        if (qtyEl) qtyEl.setAttribute('aria-invalid', 'true');
        if (msgEl) msgEl.setAttribute('aria-invalid', 'true');
        issues.push({ label: 'Quantities or message', message: reqMsg, fieldEl: qtyEl || msgEl, errorEl: reqError });
        if (!firstFocus && qtyEl) firstFocus = qtyEl;
      }

      if (!issues.length) return { valid: true, firstFocus: null };

      var summary = form.querySelector('[data-group-order-error-summary]');
      var list = form.querySelector('[data-group-order-error-list]');
      if (summary) summary.hidden = false;
      if (list) {
        list.hidden = false;
        issues.forEach(function (issue) {
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#';
          link.textContent = issue.label + ': ' + issue.message;
          link.addEventListener('click', function (e) {
            e.preventDefault();
            if (issue.fieldEl && typeof issue.fieldEl.focus === 'function') issue.fieldEl.focus();
          });
          li.appendChild(link);
          list.appendChild(li);
        });
      }

      return { valid: false, firstFocus: summary || firstFocus };
    }

    function bindGroupOrderFieldClear(form) {
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.addEventListener('input', function () {
          var errorId = field.getAttribute('aria-describedby');
          if (errorId) {
            errorId.split(/\s+/).forEach(function (id) {
              var err = document.getElementById(id);
              if (err && err.classList.contains('field-error')) clearGroupOrderFieldError(field, err);
            });
          }
          if (field.id === 'goQuantities' || field.id === 'goMessage') {
            var reqErr = form.querySelector('#goRequirements-error');
            if (reqErr && !reqErr.hidden) {
              var hasQty = form.querySelector('#goQuantities').value.trim() !== '';
              var hasMsg = form.querySelector('#goMessage').value.trim() !== '';
              if (hasQty || hasMsg) {
                reqErr.hidden = true;
                reqErr.textContent = '';
                form.querySelector('#goQuantities').removeAttribute('aria-invalid');
                form.querySelector('#goMessage').removeAttribute('aria-invalid');
              }
            }
          }
        });
        field.addEventListener('change', function () {
          if (field.type === 'checkbox' && field.hasAttribute('data-go-product')) {
            var any = false;
            form.querySelectorAll('[data-go-product]').forEach(function (cb) { if (cb.checked) any = true; });
            if (any) {
              var fs = form.querySelector('#goProductsFieldset');
              var pe = form.querySelector('#goProducts-error');
              if (fs) fs.classList.remove('go-fieldset--error');
              if (pe) { pe.hidden = true; pe.textContent = ''; }
            }
          }
        });
      });
    }

    function initGroupOrderForm() {
      var form = getGroupOrderForm();
      if (!form || form.getAttribute('data-zr-go-bound') === '1') return;
      form.setAttribute('data-zr-go-bound', '1');
      form.setAttribute('novalidate', '');

      var started = false;
      var viewed = false;
      var section = document.getElementById('groupOrderForm');

      if (section && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !viewed) {
              viewed = true;
              emitGroupOrderEvent('group_order_form_view');
              observer.disconnect();
            }
          });
        }, { threshold: 0.25 });
        observer.observe(section);
      } else if (section) {
        emitGroupOrderEvent('group_order_form_view');
      }

      form.addEventListener('focusin', function () {
        suppressPromosForFormInteraction();
        if (started) return;
        started = true;
        emitGroupOrderEvent('group_order_form_start');
      });

      form.addEventListener('submit', function (e) {
        suppressPromosForFormInteraction();
        var honeypot = form.querySelector('#groupOrderWebsite');
        if (honeypot && honeypot.value.trim() !== '') {
          e.preventDefault();
          emitGroupOrderEvent('group_order_form_error');
          return;
        }
        var result = validateGroupOrderForm(form);
        if (!result.valid) {
          e.preventDefault();
          emitGroupOrderEvent('group_order_form_error');
          scrollToGroupOrderForm(result.firstFocus);
          return;
        }
        emitGroupOrderEvent('group_order_form_submit');
      });

      bindGroupOrderFieldClear(form);

      if (form.querySelector('[data-group-order-success]')) {
        emitGroupOrderEvent('group_order_form_success');
        var success = form.querySelector('[data-group-order-success]');
        if (success) setTimeout(function () { success.focus(); }, 300);
      } else if (form.querySelector('[data-group-order-errors]')) {
        suppressPromosForFormInteraction();
        emitGroupOrderEvent('group_order_form_error');
        var serverErrors = form.querySelector('[data-group-order-errors]');
        if (serverErrors) setTimeout(function () { scrollToGroupOrderForm(serverErrors); }, 300);
      }
    }

    initGroupOrderForm();

    document.addEventListener('shopify:section:load', function () {
      initGroupOrderForm();
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#groupOrderForm"], a[href*="#groupOrderForm"]');
      if (!link || link.getAttribute('href').indexOf('#groupOrderForm') === -1) return;
      var target = document.getElementById('groupOrderForm');
      if (!target) return;
      e.preventDefault();
      suppressPromosForFormInteraction();
      scrollToGroupOrderForm(document.getElementById('groupOrderFormTitle') || target.querySelector('input, select, textarea'));
    });

    if (window.location.hash === '#groupOrderForm') {
      setTimeout(function () {
        suppressPromosForFormInteraction();
        scrollToGroupOrderForm(document.getElementById('groupOrderFormTitle') || document.querySelector('#groupOrderForm input, #groupOrderForm select, #groupOrderForm textarea'));
      }, 300);
    }
  }

  /* ---------- Tabbed PDP spec block ---------- */
  document.querySelectorAll('.tabs').forEach(function (tabs) {
    var btns = tabs.querySelectorAll('.tab-btn');
    var panels = tabs.querySelectorAll('.tab-panel');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-tab');
        btns.forEach(function (b) { b.classList.toggle('active', b === btn); });
        panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-tab') === name); });
      });
    });
  });

  /* ---------- Size guide calculator (height / weight, S–XXL) ---------- */
  (function () {
    var findBtn = document.getElementById('sgFindBtn');
    if (!findBtn) return;

    var FT_TO_CM = 30.48;
    var IN_TO_CM = 2.54;
    var LB_TO_KG = 0.453592;

    var CHART = [
      { s: 'S', height: [160, 165], weight: [55, 65] },
      { s: 'M', height: [165, 170], weight: [65, 75] },
      { s: 'L', height: [170, 178], weight: [75, 80] },
      { s: 'XL', height: [178, 185], weight: [80, 90] },
      { s: 'XXL', height: [180, 190], weight: [90, 100] }
    ];

    var heightUnitEl = document.getElementById('sgHeightUnit');
    var weightUnitEl = document.getElementById('sgWeightUnit');
    var heightCmEl = document.getElementById('sgHeightCm');
    var heightFtEl = document.getElementById('sgHeightFt');
    var heightInEl = document.getElementById('sgHeightIn');
    var heightCmRow = document.getElementById('sgHeightCmRow');
    var heightFtInRow = document.getElementById('sgHeightFtInRow');
    var weightEl = document.getElementById('sgWeight');
    var weightLabel = document.getElementById('sgWeightLabel');
    var feedbackEl = document.getElementById('sgFeedback');
    var resultEl = document.getElementById('sgResult');
    var recommendationEl = document.getElementById('sgRecommendation');
    var noteEl = document.getElementById('sgNote');

    var inputs = [heightCmEl, heightFtEl, heightInEl, weightEl].filter(Boolean);

    function parseNum(raw) {
      var text = String(raw || '').trim();
      if (text === '') return { empty: true };
      if (!/^\d+(\.\d+)?$/.test(text)) return { invalid: true };
      var value = parseFloat(text);
      if (isNaN(value) || value < 0) return { invalid: true };
      return { value: value };
    }

    function globalRange(key) {
      return {
        min: CHART[0][key][0],
        max: CHART[CHART.length - 1][key][1]
      };
    }

    function sizeForValue(value, key) {
      var bounds = globalRange(key);
      if (value < bounds.min || value > bounds.max) return { outOfRange: true };

      var matches = [];
      for (var i = 0; i < CHART.length; i++) {
        var min = CHART[i][key][0];
        var max = CHART[i][key][1];
        if (value >= min && value <= max) matches.push(i);
      }

      if (!matches.length) return { outOfRange: true };

      var index = matches[0];
      var overlap = matches.length > 1;
      var onBoundary = overlap;
      if (!onBoundary && index < CHART.length - 1) {
        onBoundary = value === CHART[index][key][1] && value === CHART[index + 1][key][0];
      }

      return { size: CHART[index].s, index: index, overlap: overlap, onBoundary: onBoundary };
    }

    function setInvalid(on) {
      inputs.forEach(function (input) {
        if (!input) return;
        if (input === heightCmEl && heightUnitEl && heightUnitEl.value === 'ftin') return;
        if ((input === heightFtEl || input === heightInEl) && heightUnitEl && heightUnitEl.value === 'cm') return;
        input.setAttribute('aria-invalid', on ? 'true' : 'false');
      });
    }

    function hideResult() {
      if (resultEl) {
        resultEl.hidden = true;
        resultEl.removeAttribute('tabindex');
      }
      if (recommendationEl) recommendationEl.textContent = '';
      if (noteEl) {
        noteEl.textContent = '';
        noteEl.hidden = true;
      }
    }

    function showError(msg) {
      hideResult();
      setInvalid(true);
      if (feedbackEl) {
        feedbackEl.textContent = msg;
        feedbackEl.setAttribute('tabindex', '-1');
        feedbackEl.focus();
      }
    }

    function showSuccess(size, note) {
      setInvalid(false);
      if (feedbackEl) {
        feedbackEl.textContent = '';
        feedbackEl.removeAttribute('tabindex');
      }
      if (recommendationEl) recommendationEl.textContent = 'Recommended size: ' + size + '.';
      if (noteEl) {
        if (note) {
          noteEl.textContent = note;
          noteEl.hidden = false;
        } else {
          noteEl.textContent = '';
          noteEl.hidden = true;
        }
      }
      if (resultEl) {
        resultEl.hidden = false;
        resultEl.setAttribute('tabindex', '-1');
        resultEl.focus();
      }
    }

    function updateHeightUi() {
      var useFtIn = heightUnitEl && heightUnitEl.value === 'ftin';
      if (heightCmRow) heightCmRow.hidden = useFtIn;
      if (heightFtInRow) heightFtInRow.hidden = !useFtIn;
    }

    function updateWeightUi() {
      var useLb = weightUnitEl && weightUnitEl.value === 'lb';
      if (weightLabel) weightLabel.textContent = useLb ? 'Weight (lb)' : 'Weight (kg)';
      if (weightEl) weightEl.placeholder = useLb ? 'e.g. 154' : 'e.g. 70';
    }

    function readHeightCm() {
      if (heightUnitEl && heightUnitEl.value === 'ftin') {
        var ft = parseNum(heightFtEl ? heightFtEl.value : '');
        var inches = parseNum(heightInEl ? heightInEl.value : '');
        if (ft.empty && inches.empty) return { empty: true };
        if (ft.invalid || inches.invalid) return { invalid: true };
        var ftVal = ft.empty ? 0 : ft.value;
        var inVal = inches.empty ? 0 : inches.value;
        if (ftVal === 0 && inVal === 0) return { empty: true };
        return { value: ftVal * FT_TO_CM + inVal * IN_TO_CM };
      }
      return parseNum(heightCmEl ? heightCmEl.value : '');
    }

    function readWeightKg() {
      var parsed = parseNum(weightEl ? weightEl.value : '');
      if (parsed.empty || parsed.invalid || parsed.value === undefined) return parsed;
      var useLb = weightUnitEl && weightUnitEl.value === 'lb';
      return { value: useLb ? parsed.value * LB_TO_KG : parsed.value };
    }

    if (heightUnitEl) heightUnitEl.addEventListener('change', updateHeightUi);
    if (weightUnitEl) weightUnitEl.addEventListener('change', updateWeightUi);
    updateHeightUi();
    updateWeightUi();

    findBtn.addEventListener('click', function () {
      var height = readHeightCm();
      var weight = readWeightKg();

      if (height.empty || weight.empty) {
        showError('Please enter your height and weight.');
        return;
      }

      if (height.invalid || weight.invalid) {
        showError('Please enter numbers only.');
        return;
      }

      var heightResult = sizeForValue(height.value, 'height');
      var weightResult = sizeForValue(weight.value, 'weight');

      if (heightResult.outOfRange || weightResult.outOfRange) {
        showError('Your measurements fall outside our published size range. Please contact us for personalised sizing help.');
        return;
      }

      var finalIndex = Math.max(heightResult.index, weightResult.index);
      var finalSize = CHART[finalIndex].s;
      var note = '';

      if (heightResult.index !== weightResult.index) {
        note = 'Your height and weight sit across two sizes. For a comfortable fit, we recommend sizing up.';
      } else if (heightResult.onBoundary || weightResult.onBoundary || heightResult.overlap || weightResult.overlap) {
        note = 'You are close to the next size. For a comfortable fit, we recommend sizing up.';
      }

      showSuccess(finalSize, note);
    });
  })();

  /* ---------- Inline newsletter forms ----------
     Shopify's customer form submits natively and re-renders with the real
     success or error state, so no simulated feedback is shown here. */

  /* ---------- Collection filtering & sorting (client-side) ---------- */
  var grid = document.querySelector('.product-grid[data-filterable]');
  var fcat = document.querySelector('.f-cat');
  if (grid && fcat) {
    var fsize = document.querySelector('.f-size');
    var fprice = document.querySelector('.f-price');
    var fsort = document.querySelector('.f-sort');
    var countEl = document.getElementById('prodCount');
    var noResults = document.getElementById('noResults');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));

    function cardSizes(c) { return (c.getAttribute('data-sizes') || '').trim().split(/\s+/); }
    function cardPrice(c) { return parseFloat(c.getAttribute('data-price') || '0'); }
    function cardCategory(c) { return c.getAttribute('data-cat') || ''; }
    function matchesPrice(p, price) {
      if (price === 'any') return true;
      if (price === 'u30') return p < 30;
      if (price === '30-60') return p >= 30 && p <= 60;
      if (price === '60+') return p > 60;
      return true;
    }
    function cardMatches(c, cat, size, price) {
      if (cat !== 'all' && cardCategory(c) !== cat) return false;
      if (size !== 'all' && cardSizes(c).indexOf(size) === -1) return false;
      if (!matchesPrice(cardPrice(c), price)) return false;
      return true;
    }
    function applyFilters() {
      var cat = fcat.value, size = fsize ? fsize.value : 'all', price = fprice ? fprice.value : 'any', sort = fsort ? fsort.value : 'featured';
      var visible = cards.filter(function (c) { return cardMatches(c, cat, size, price); });
      if (sort === 'price-asc') visible.sort(function (a, b) { return cardPrice(a) - cardPrice(b); });
      else if (sort === 'price-desc') visible.sort(function (a, b) { return cardPrice(b) - cardPrice(a); });
      else if (sort === 'rating') visible.sort(function (a, b) { return (b.dataset.reviews | 0) - (a.dataset.reviews | 0); });
      cards.forEach(function (c) { c.hidden = true; });
      visible.forEach(function (c) { c.hidden = false; grid.appendChild(c); });
      if (countEl) countEl.textContent = visible.length + (visible.length === 1 ? ' product' : ' products');
      if (noResults) noResults.style.display = visible.length ? 'none' : 'block';
    }
    function setSel(sel, val) {
      if (!val || !sel) return;
      var m = Array.prototype.find.call(sel.options, function (o) { return o.value === val; });
      if (m) sel.value = val;
    }
    var params = new URLSearchParams(window.location.search);
    setSel(fcat, params.get('cat'));
    setSel(fsize, params.get('size'));
    setSel(fprice, params.get('price'));
    setSel(fsort, params.get('sort'));
    [fcat, fsize, fprice, fsort].forEach(function (s) { if (s) s.addEventListener('change', applyFilters); });
    var clear = document.getElementById('clearFilters');
    if (clear) clear.addEventListener('click', function (e) {
      e.preventDefault();
      fcat.value = 'all'; if (fsize) fsize.value = 'all'; if (fprice) fprice.value = 'any'; if (fsort) fsort.value = 'featured';
      applyFilters();
    });
    applyFilters();
  }

  /* ---------- Homepage scroll reveal ---------- */
  if (document.body.classList.contains('home-page')) {
    document.body.classList.add('js');
    var revealEls = document.querySelectorAll('.scroll-reveal');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { obs.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Hash anchor scroll (sticky header offset) ---------- */
  if (window.location.hash) {
    var target = document.querySelector(window.location.hash);
    if (target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
  }

  refreshCart();
  initProductSizeGuideModal();

  if (getCartRoot()) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        zrEmit('cart_view', {
          item_count: cart.item_count,
          cart_subtotal: cart.items_subtotal_price,
          source: 'cart_page'
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var checkout = e.target.closest('[name="checkout"], .cart-checkout, [data-cart-checkout]');
    if (checkout && getCartRoot()) {
      zrEmit('checkout_click', { source: 'cart_page' });
      return;
    }

    var policy = e.target.closest('a[href*="shipping"], a[href*="returns"], a[href*="policy"]');
    if (policy && policy.pathname) {
      zrEmit('policy_link_click', {
        link_path: policy.pathname,
        source: policy.closest('footer') ? 'footer' : 'content'
      });
    }

    var navLink = e.target.closest('.nav a, .mobile-nav-links a, .header-actions a, .site-footer a, footer a');
    if (navLink && navLink.href) {
      try {
        var url = new URL(navLink.href, window.location.origin);
        if (url.origin === window.location.origin) {
          zrEmit('navigation_click', {
            link_path: url.pathname,
            source: navLink.closest('.mobile-nav-links') ? 'mobile_nav' : (navLink.closest('footer') ? 'footer' : 'header')
          });
        }
      } catch (err) {}
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var searchForm = e.target.closest('form[action*="/search"]');
    if (searchForm) {
      zrEmit('search_submit', { source: 'search_form' });
      return;
    }

    var contactForm = e.target.closest('.contact-form');
    if (contactForm) {
      zrEmit('contact_form_submit', { source: 'contact_page' });
    }
  }, true);

  if (document.querySelector('.contact-form [data-contact-success]')) {
    zrEmit('contact_form_success', { source: 'contact_page' });
  } else if (document.querySelector('.contact-form [data-contact-errors]')) {
    zrEmit('contact_form_error', { source: 'contact_page' });
  }

  if (document.body && document.body.classList.contains('template-search')) {
    zrEmit('search_open', { source: 'search_page' });
  }
})();
